<input [(ngModel)]="hamburgerOpen" type="checkbox" id="hamburger" name="hamburger" (change)="openHamburger()">
<label for="hamburger" class="hamburger hamburger--spring">
  <div class="hamburger-box">
    <div class="hamburger-inner"></div>
  </div>
</label>
<div class="menu-container" [ngClass]="[hamburgerOpen ? 'hamburger-open' : 'hamburger-closed']">
  <div class="menu"></div>
  <h1><a [routerLink]="''" [matTooltip]="'Kyloe DataTools Home'" matTooltipShowDelay="500">Kyloe DataTools</a></h1>
  <ul class="links">
    <li>
           <span>
               <a [ngClass]="{ 'current-section' : currentSection == DataToolsAppsTitles.DATA_CLEANER,
                               'disabled' : !(appEnabled(DataToolsApps.DATA_CLEANER)) }"
                  (click)="goToApp(DataToolsApps.DATA_CLEANER)" (keydown.enter)="goToApp(DataToolsApps.DATA_CLEANER)" tabindex="1" appRipple>
                    <i class="DataCleaner-KyloeIcon KyloeIcon"></i>
                 {{DataToolsAppsTitles.DATA_CLEANER}}
                </a>
           </span>
    </li>
    <li>
            <span>
                <a [ngClass]="{ 'current-section' : currentSection == DataToolsAppsTitles.DUPLIKIT,
                                'disabled' :!(appEnabled(DataToolsApps.DUPLIKIT)) }"
                   (click)="goToApp(DataToolsApps.DUPLIKIT)" (keydown.enter)="goToApp(DataToolsApps.DUPLIKIT)" tabindex="2" appRipple>
                    <i class="DupliKit-KyloeIcon KyloeIcon"></i>
                  {{DataToolsAppsTitles.DUPLIKIT}}
                </a>
            </span>
    </li>
    <li>
            <span>
                <a [ngClass]="{ 'current-section' : currentSection == DataToolsAppsTitles.DATARULES,
                                'disabled' :!(appEnabled(DataToolsApps.DATARULES)) }"
                   (click)="goToApp(DataToolsApps.DATARULES)" (keydown.enter)="goToApp(DataToolsApps.DATARULES)"
                   tabindex="3" appRipple>
                    <i class="DataRules-KyloeIcon KyloeIcon"></i>
                  {{DataToolsAppsTitles.DATARULES}}
                </a>
            </span>
    </li>
    <li *ngIf="userStatus().adminUser">
                  <span>
                      <a [ngClass]="{ 'current-section' : currentSection == DataToolsAppsTitles.USER_MANAGEMENT}"
                         (click)="goToApp(DataToolsApps.USER_MANAGEMENT)"
                         (keydown.enter)="goToApp(DataToolsApps.USER_MANAGEMENT)" tabindex="3" appRipple>
                        <i class="UserManagement-KyloeIcon KyloeIcon"></i>
                        {{DataToolsAppsTitles.USER_MANAGEMENT}}
                      </a>
                  </span>
    </li>
    <ul id="datatools-history-links" class="sub-links" [ngClass]="{'expanded' : toggleHamburgerHistory}">
      <li class="sub-link-title">
            <span>
                <a [ngClass]="{ 'current-section' : currentSection == DataToolsAppsTitles.HISTORY,
                                'disabled' : !(appEnabled(DataToolsApps.DATARULES)) && !(appEnabled(DataToolsApps.DUPLIKIT)) }"
                   (click)="toggleHamburgerHistory = !toggleHamburgerHistory"
                   (keydown.enter)="toggleHamburgerHistory = !toggleHamburgerHistory" tabindex="4" appRipple>
                    <i class="History-KyloeIcon KyloeIcon"></i>
                  {{DataToolsAppsTitles.HISTORY}}
                  <i class="bhi-sort-desc"></i>
                </a>
            </span>
      </li>
      <li>
              <span>
                  <a [ngClass]="{ 'current-section' : currentSection == DataToolsAppsTitles.HISTORY && currentChildSection == DataToolsAppsTitles.DUPLIKIT,
                                'disabled' :!(appEnabled(DataToolsApps.DUPLIKIT)) }"
                     (click)="goToApp(DataToolsApps.HISTORY_DUPLIKIT)" (keydown.enter)="goToApp(DataToolsApps.HISTORY_DUPLIKIT)" appRipple>
                      <i class="DupliKit-KyloeIcon KyloeIcon"></i>
                    {{DataToolsAppsTitles.DUPLIKIT}}
                  </a>
              </span>
      </li>
      <li>
              <span>
                  <a [ngClass]="{ 'current-section' : currentSection == DataToolsAppsTitles.HISTORY && currentChildSection == DataToolsAppsTitles.DATARULES,
                                'disabled' :!(appEnabled(DataToolsApps.DATARULES)) }"
                     (click)="goToApp(DataToolsApps.HISTORY_DATARULES)" (keydown.enter)="goToApp(DataToolsApps.HISTORY_DATARULES)" appRipple>
                      <i class="DataRules-KyloeIcon KyloeIcon"></i>
                    {{DataToolsAppsTitles.DATARULES}}
                  </a>
              </span>
      </li>
      <li *ffEnabled="'datarules_enrichment_action'"> <!-- TODO: use enrichment entitlement. -->
              <span>
                  <a [ngClass]="{ 'current-section' : currentSection == DataToolsAppsTitles.HISTORY && currentChildSection == DataToolsAppsTitles.ENRICHMENT_CREDIT_HISTORY}"
                     (click)="goToApp(DataToolsApps.HISTORY_ENRICHMENT_CREDITS)" (keydown.enter)="goToApp(DataToolsApps.HISTORY_ENRICHMENT_CREDITS)" appRipple>
                      <i class="Enrichment-KyloeIcon KyloeIcon"></i>
                    {{DataToolsAppsTitles.ENRICHMENT_CREDIT_HISTORY}}
                  </a>
              </span>
      </li>
    </ul>
    <ul *ffEnabled="'datarules_enrichment_action'; else noEnrichmentSettings" id="datatools-settings-links" class="sub-links" [ngClass]="{'expanded' : toggleHamburgerSettings}">
      <li class="sub-link-title">
            <span>
                <a [ngClass]="{ 'current-section' : currentSection == DataToolsAppsTitles.DATATOOLS_SETTINGS || currentSection == DataToolsAppsTitles.ENRICHMENT_SETTINGS,
                                'disabled' : !userStatus().authorizedUser || (!appEnabled(DataToolsApps.DUPLIKIT) && !appEnabled(DataToolsApps.DATARULES)) }"
                   (click)="toggleHamburgerSettings = !toggleHamburgerSettings"
                   (keydown.enter)="toggleHamburgerSettings = !toggleHamburgerSettings" tabindex="5" appRipple>
                    <i class="Settings-KyloeIcon KyloeIcon"></i>
                    Settings
                    <i class="bhi-sort-desc"></i>
                </a>
            </span>
      </li>
      <li>
            <span>
                <a [ngClass]="{ 'current-section' : currentSection == DataToolsAppsTitles.DATATOOLS_SETTINGS,
                                'disabled' : !userStatus().authorizedUser || !appEnabled(DataToolsApps.DUPLIKIT) }"
                   (click)="goToSettings()" (keydown.enter)="goToSettings()" appRipple>
                    <i class="DupliKit-KyloeIcon KyloeIcon"></i>
                  {{DataToolsAppsTitles.DUPLIKIT}}
                </a>
            </span>
      </li>
      <li>
            <span>
                <a [ngClass]="{ 'current-section' : currentSection == DataToolsAppsTitles.ENRICHMENT_SETTINGS}"
                   (click)="goToApp(DataToolsApps.ENRICHMENT_SETTINGS)" (keydown.enter)="goToApp(DataToolsApps.ENRICHMENT_SETTINGS)" appRipple>
                    <i class="Enrichment-KyloeIcon KyloeIcon"></i>
                  {{DataToolsAppsTitles.ENRICHMENT_SETTINGS}}
                </a>
            </span>
      </li>
    </ul>
    <ng-template #noEnrichmentSettings>
      <li>
            <span>
                <a [ngClass]="{ 'current-section' : currentSection == DataToolsAppsTitles.DATATOOLS_SETTINGS ,
                                'disabled' :!userStatus().authorizedUser || !appEnabled(DataToolsApps.DUPLIKIT) }"
                   (click)="goToSettings()" (keydown.enter)="goToSettings()" tabindex="5" appRipple>
                    <i class="Settings-KyloeIcon KyloeIcon"></i>
                  {{DataToolsAppsTitles.DATATOOLS_SETTINGS}}
                </a>
            </span>
      </li>
    </ng-template>
  </ul>
</div>
